import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { map, Observable } from 'rxjs';
import { ConfirmActionDialogComponent } from 'src/app/common/confirm-action-dialog/confirm-action-dialog.component';
import { InfoDialogComponent } from 'src/app/common/info-dialog/info-dialog.component';

@Injectable({ providedIn: 'root' })
export class AlertService {
  private options: Partial<IndividualConfig> = {
    positionClass: 'giq-toast-top-right',
    enableHtml: true,
    tapToDismiss: true,
  };
  constructor(private toastr: ToastrService, private dialog: MatDialog) {}

  public error(
    message: string,
    title: string | null = null,
    options: Partial<IndividualConfig> | null = null
  ): void {
    const finalOptions = this.processDefaultOptions(options);
    this.toastr.error(message, title ?? 'Error', finalOptions);
  }

  public warning(
    message: string,
    options: Partial<IndividualConfig> | null = null
  ): void {
    const finalOptions = this.processDefaultOptions(options);
    this.toastr.warning(message, undefined, finalOptions);
  }

  public success(
    message: string,
    options: Partial<IndividualConfig> | null = null
  ): void {
    const finalOptions = this.processDefaultOptions(options);
    this.toastr.success(message, undefined, finalOptions);
  }

  public confirmDialog(
    title: string,
    message: string,
    params?: { [key: string]: object },
    isHtml?: boolean
  ): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmActionDialogComponent, {
      disableClose: true,
      data: {
        title,
        message,
        isHtml: isHtml,
        params: params,
      },
    });

    return dialogRef.afterClosed().pipe(
      map((data: boolean) => {
        return data;
      })
    );
  }

  public infoDialog(params: {
    content: string;
    showOkButton: boolean;
    title?: string | undefined;
    dontShowAgainId?: string | undefined;
    okButtonText?: string | undefined;
  }): Observable<string | undefined> {
    if (params.dontShowAgainId) {
      const dontShowAgain = localStorage.getItem(
        'dnsa-' + params.dontShowAgainId
      );
      if (dontShowAgain === 'noShow') {
        return new Observable<string | undefined>((observer) => {
          observer.next('void');
          observer.complete();
        });
      }
    }
    const parms = { ...params, dontShowAgain: params.dontShowAgainId != null };
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      data: parms,
    });
    return dialogRef.afterClosed().pipe(
      map(
        (
          x: { button: string | undefined; dontShowAgain: boolean } | undefined
        ) => {
          if (x == null) {
            return undefined;
          }
          if (x.dontShowAgain === true && params.dontShowAgainId) {
            localStorage.setItem('dnsa-' + params.dontShowAgainId, 'noShow');
          }
          return x.button;
        }
      )
    );
  }

  private processDefaultOptions(
    options: Partial<IndividualConfig> | null
  ): Partial<IndividualConfig> | undefined {
    if (options == null) {
      return undefined;
    }

    const finalOptions =
      options != null ? { ...this.options, ...options } : this.options;

    if (
      finalOptions.tapToDismiss == true &&
      finalOptions.timeOut == undefined &&
      finalOptions.disableTimeOut == undefined
    ) {
      finalOptions.disableTimeOut = true;
      finalOptions.closeButton = true;
    }

    return finalOptions;
  }
}
